import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import FlexibleProductEditView from '@components/shared/flexible_products/FlexibleProductEditView';
import useRecordMerchantSync from '@hooks/operator/useRecordMerchantSync';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';
import PageHeader from '@shared/PageHeader';
import { useParams } from 'react-router-dom';

import operatorFlexibleProductService from '@services/operator/flexibleProductService';

const OperatorFlexibleProductEdit: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const productService = useOperatorProductService();
  const { recordMerchantId, handleRecordLoaded, merchantDataLoading } = useRecordMerchantSync();

  // 編輯模式：merchant 只由 record 推導。loader 回來前 recordMerchantId 為 null，
  // shared 會 early-return spinner（不會 mount 任何 merchant-scoped 子元件）。
  // 不可 fallback 到 currentMerchant?.id —— 那會在 sync 完成前用 header merchant
  // render ProductSelect / 下拉，正是本次 sweep 在堵的 cross-merchant bug class。
  if (id) {
    return (
      <div>
        <PageHeader items={['products', 'products.flexible_products', 'products.flexible_products.edit']} />
        <FlexibleProductEditView
          flexibleProductService={operatorFlexibleProductService}
          productService={productService}
          role="operator"
          merchantId={recordMerchantId}
          onFlexibleProductLoaded={handleRecordLoaded}
          merchantDataLoading={merchantDataLoading}
        />
      </div>
    );
  }

  // 新增走 New.jsx；此分支為保險：若路由直接命中 Edit 但沒 id，走 MerchantSelect 流程
  return (
    <MerchantSelect>
      {({ merchantId }: { merchantId: string | null | undefined }) => (
        <div>
          <PageHeader items={['products', 'products.flexible_products', 'products.flexible_products.new']} />
          {merchantId && (
            <FlexibleProductEditView
              flexibleProductService={operatorFlexibleProductService}
              productService={productService}
              role="operator"
              merchantId={merchantId}
            />
          )}
        </div>
      )}
    </MerchantSelect>
  );
};

export default OperatorFlexibleProductEdit;
